export default {
    home: {
        rating: {
            heading: {
                professional: {
                    heading: 'My professional score',
                    info: 'This is a platform generated scoring of provider credentials with a range of 3 - 5.',
                },
                medmatch: {
                    heading: 'My MedMatch Network rating',
                    info: "This is a peer-to-peer rating reflecting the provider's performance on the platform with a range of 1 - 5.",
                },
            },
        },
        profile_reminder: {
            percentage: 'PROFILE {profilePercentage}% COMPLETED',
            improve_rating: 'Create your professional score.',
            complete_profile: 'Complete your professional profile',
            increase_chances: 'to increase your chances to receive referrals.',
        },
        select_tests_reminder: {
            header: 'Select Test',
            practice_profile: 'Go to Practice Profile',
            select_tests: 'to select tests for services you provide',
        },
        connections: {
            heading: 'New members in your area',
            physicians: 'Providers',
            ancillary: 'Ancillary Services',
            member: 'Invite a Provider',
            colleague: 'Invite Service Provider',
            show_all: 'See all members in your area',
            new_members: 'New members',
            in_geographic_area: 'in your geographic area',
            will_appear: 'will appear here',
            modals: {
                invite: {
                    physician: {
                        header_text: 'Invite your favorite providers to join MedMatch',
                        label: 'Provider',
                        placeholder: 'provider@email.com',
                        button_label: 'SEND INVITATION',
                        practice_type: 'provider',
                    },
                    ancillary: {
                        header_text: 'Invite your favorite ancillary service providers to join MedMatch',
                        label: 'Provider',
                        placeholder: 'provider@email.com',
                        button_label: 'SEND INVITATION',
                        practice_type: 'ancillary',
                    },
                },
            },
        },
        referrals: {
            heading: 'My pending connections',
            made: 'Made',
            received: 'Received',
        },
        invitations_sent: {
            successful: 'Invites sent!',
        },
        practice_reminder: {
            create_company_info: 'Please complete company profile to invite other providers to your network.',
            create_company: 'Create Company',
        },
    },

    referrals: {
        card: {
            check_availability: 'Check availability',
            schedule_not_set: 'Schedule not set',
            not_medmatch_member: 'Not a MedMatch Network member',
            email_verification_pending: 'Email verification pending',
            availability_not_set: 'AVAILABILITY NOT SET',
            set_availability_now: 'SET AVAILABILITY NOW',
            see_contact_details: 'See contact details',
            referrals: 'referrals',
            invited_on: 'Invited on {date}',
            connections: 'connections',
            new: 'NEW',
            select_location: 'Select a location',
            phone: 'Phone',
            pending: 'pending',
            allow_membership: 'Allow membership?',
            buttons: {
                deny: 'Deny',
                allow: 'Allow',
                reinvite: 'Re-invite Provider',
                reinvite_practice: 'Re-invite Ancillary',
            },
            context_menu: {
                modify_privileges: 'Modify privileges',
                remove_member: 'Remove member',
            },
            invite_user_to_join: 'You may invite {name} to join MedMatch',
            user_already_invited: '{name} has been invited to join MedMatch',
            user_being_invited: 'Invitation is being sent to {name}',
            registration_not_completed: '{name} has not completed the registration process yet',
            registration_completed: '{name} is registered',
            send_reminder: 'Send a reminder?',
            physician_group: 'Member of:',
            reminder_sent: 'Reminder sent!',
        },
        messages: {
            message_row: {
                header_text: 'you wrote',
            },
        },
    },

    network: {
        email_collector: {
            add_email_link: 'Add email field',
            add_phone_link: 'Add phone number field',
            input_field_title: 'Enter email address',
            input_field_phone_title: 'Enter phone number',
            email: 'email',
            phone: 'phone',
            phone_placeholder: 'member phone number',
            invalid_email_address: 'Invalid email address!',
            invalid_phone_number: 'Invalid phone number!',
            first_name: 'First name',
            last_name: 'Last name',
        },
        request_appointment_at_join_invite: {
            role_physician: 'Provider',
            role_ancillary: 'Ancillary Service Provider',
            unfortunately: 'Unfortunately,',
            has_not_yet_accepted:
                'has not yet accepted your invitation to complete their MedMatch Network signup. We can send them a reminder if you like, together with your personal note, which you can enter below:',
            type_a_message_for: 'Type a message for',
            text_area_placeholder: 'Hi, I would like to set an appointment for my patient...',
            buttons: {
                send: 'SEND',
            },
        },
        my_connections_list_filter: {
            connections_all: 'All',
            connections_from_me: 'Connections I added',
            connections_to_me: 'Connections who added me',
        },
        network_inclusion_status: {
            buttons: {
                in_my_network: 'In my network',
                add_to_my_network: 'Add to my network',
            },
        },
        contact_collector: {
            heading: 'Select contacts',
            placeholder: 'Search for contacts',
        },
    },

    profile: {
        professional: {
            header_text: '{physicianName} profile',
            your_profile: 'Your profile',
        },
    },

    availability: {
        schedule_timeline: {
            previusly: 'Previusly: {hours}.',
            changed_to: 'Automatically changed to fit new appointment length.',
        },
    },

    search_autocomplete: {
        physician: 'Provider',
        referral_type: 'Referral {type} | {date}',
        ancillary: 'Ancillary service | {address}',
    },

    referral_details_card: {
        referred_physician: 'Referred provider',
        referring_physician: 'Referring provider',
        patient: 'Patient',
    },

    practice_member_filter: {
        all: 'All',
        physicians: 'Providers',
        order_by: 'Order by',
        pending_approval: 'Pending approval',
        buttons: {
            invite_practice_members: 'Invite Practice members',
            invite_by_email: 'Invite by email',
            invite_by_phone: 'Invite by phone',
        },
    },

    practice_members_count: {
        pending_count: '{count} waiting for admin permission',
    },
}
